import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'dutyStatusDuration' })
export class DutyStatusDurationPipe implements PipeTransform {
  public transform(duration) {
    return duration ? (Math.round((duration / 3600) * 100) / 100).toFixed(2) : 0;
  }
}
